<template>
  <div>
    <form
      id="searchSection"
      onsubmit="return false;"
      style="margin-top: 30px;"
    >
      <div
        class="choice"
        style="width:100%"
      >
        <select
          name="status"
          class="s-select separate"
          v-model="queryInfo.type"
        >
          <option value="">请选择所属专业领域</option>
          <option
            v-for="(v, k) in dict_org_major_type"
            :key="k"
            :value="k"
          >{{ v }}</option>
        </select>
        <select
          name="status"
          class="s-select separate"
          v-model="queryInfo.is_show"
        >
          <option value="">首页列表显示</option>
          <option value="1">已显示</option>
          <option value="0">不显示</option>
        </select>
        <input
          type="text"
          name="title"
          class="s-input separate"
          placeholder="专委会名称"
          v-model="queryInfo.major_name"
        >
        <input
          type="text"
          name="code"
          class="s-input separate"
          placeholder="姓名"
          v-model="queryInfo.name"
        >
        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="search"
        >

        <div
          class="add-btn"
          @click="showInfoWindow"
        >新建</div>
        <div
          class="import-btn"
          id="batchUpload"
          @click="showUploadWindow"
        >导入</div>
      </div>
    </form>
    <div id="list">
      <table v-if="this.tableData.length > 0">
        <tbody>
          <tr class="l_header">
            <th class="itemStatus">序号</th>
            <th class="itemStatus">所属专业领域</th>
            <th class="itemStatus">专委会名称</th>
            <th class="itemStatus">职位</th>
            <th class="itemStatus">单位名称</th>
            <th class="itemStatus">姓名</th>
            <th class="itemStatus">所在部门</th>
            <th class="itemStatus">职称/职务</th>
            <th class="itemStatus">首页列表显示</th>
            <th
              class="action"
              width="180"
            >操作</th>
          </tr>
          <tr
            class="item"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <td class="itemStatus">{{ index + 1 }}</td>
            <td class="itemStatus">{{ formatType(item.type) }}</td>
            <td class="itemStatus">{{ item.major_name }}</td>
            <td class="itemStatus">{{ item.position }}</td>
            <td class="itemStatus">{{ item.org_name }}</td>
            <td class="itemStatus">{{ item.name }}</td>
            <td class="itemStatus">{{ item.dep_name }}</td>
            <td class="itemStatus">{{ item.duty }}</td>
            <td class="itemStatus">
              <a
                v-if="item.is_show==1"
                class="nopublish"
                href="javascript:;"
                @click="askShow(item.id, 0)"
              >已显示</a>
              <a
                v-if="item.is_show==0"
                class="publish"
                href="javascript:;"
                @click="askShow(item.id, 1)"
              >显示</a>
            </td>
            <td class="action">
              <a
                class="edit"
                href="javascript:;"
                @click="querySingle(item.id)"
              >编辑</a>
              <a
                class="delete"
                href="javascript:;"
                @click="askDel(item.id)"
              >删除</a>

            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="noitems"
        v-if="tableData.length == 0"
      >没有数据</div>

      <pagination
        :cur="pageInfo.page"
        :all="pageInfo.all"
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowInfoWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">专委会添加</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label">所属专业领域:</span>
              <select
                name="attr"
                v-model="formInfo.type"
              >
                <option value="">请选择所属专业领域</option>
                <option
                  v-for="(v, k) in dict_org_major_type"
                  :key="k"
                  :value="k"
                >{{ v }}</option>
              </select>
            </div>
            <div class="item">
              <span class="label">专委会名称:</span>
              <input
                type="text"
                v-model="formInfo.major_name"
              >
            </div>
            <div class="item">
              <span class="label">职位:</span>
              <input
                type="text"
                v-model="formInfo.position"
              >
            </div>
            <div class="item">
              <span class="label">工作单位:</span>
              <input
                type="text"
                v-model="formInfo.org_name"
              >
            </div>
            <div class="item">
              <span class="label">姓名:</span>
              <input
                type="text"
                v-model="formInfo.name"
              >
            </div>
            <div class="item">
              <span class="label">所在部门:</span>
              <input
                type="text"
                v-model="formInfo.dep_name"
              >
            </div>
            <div class="item">
              <span class="label">职称/职务:</span>
              <input
                type="text"
                v-model="formInfo.duty"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideInfoWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      :style="classShowUploadWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">批量上传</div>
        <div class="form_content">
          <form id="uploadForm">
            <div class="item">
              <span
                class="label"
                style="width: auto"
              ><i class="require"></i>模版创建规则:</span>
              <div class="item-box divLabel gray">
                <div class="normal-width">
                  <p>1. 文件格式为Excel文件；</p>
                  <p>2. 表格头说明：
                    class（专业类领域）、group（专委会名称）、title（职位）、unit（单位）、name（姓名）、section（所在部门）、post（职称）、fixed（是否在首页列表显示1为显示0为不显示）</p>
                </div>
              </div>
              <div class="clear"></div>
              <div class="attachment">
                <a
                  href="/static/upload_template/batch_upload_major_template.csv"
                  download="batch_upload_major_template.csv"
                  target="_blank"
                >模版下载</a>
              </div>
            </div>
            <div class="item">
              <span
                class="label"
                style="width: auto"
              ><i class="require"></i></span>
              <div
                class="item-box"
                style="margin-left: 130px;"
              >
                <input
                  name="file"
                  v-model="uploadedCsv"
                  disabled
                  type="text"
                  id="fileUrl"
                  style="width: 225px;"
                >
                <span
                  class="button"
                  style="position: relative;top: 0px; left: 0px;"
                >
                  选择文件
                  <input
                    @change="xlsChange"
                    type="file"
                    ref="xlsFile"
                    id="fileUpload"
                    class="upload-derict"
                  >
                </span>
              </div>
              <div class="clear"></div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_upload_close"
            @click="hideUploadWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_upload_submit"
            @click="submitCsv"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      id="dialog_overlay"
      :style="classShowProcessWindow"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        ref="refErrorList"
        style="margin-left: -136px; margin-top: -54px;max-width: 300px;"
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">提示</div>
        <div id="dialog_content">
          ({{ curCsvIndex }} / {{ uploadedCscData.length }})
          <span style="color: #219d2b">
            {{ ' ' + csvFinishText }}
          </span>
        </div>
        <div id="dialog_content2">
          <ul>
            <li
              v-for="(item, index) in errorList"
              v-bind:key="index"
            >
              <span :class="item.code == 1 ? 'success' : 'fail'">{{ item.text }}</span>
            </li>
          </ul>

        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            id="dialog_ok"
            class="button col2"
            @click="classShowProcessWindow={}"
            :style="isFinishUpsert ? 'display: inline-block' : 'display:none'"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../../components/Pagination";

export default {
  name: "AdminOrgMajor",
  components: {
    Pagination
  },
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        type: '',
        is_show: '',
        major_name: '',
        name: '',
      },
      formInfo: {
        id: 0,
        type: '',
        major_name: '',
        position: '',
        org_name: '',
        name: '',
        dep_name: '',
        duty: '',
      },
      tableData: [],
      tableDataCount: 0,
      showWindow: false,
      classShowUploadWindow: {},
      uploadedCsv: '',
      uploadedCscData: [],
      classShowProcessWindow: {},
      errorList: [],
      isFinishUpsert: false,
      curCsvIndex: 0,
      csvFinishText: ''
    }
  },
  computed: {
    classShowInfoWindow() {
      if (this.showWindow) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    dict_org_major_type() {
      return this.$store.state.dict_org_major_type;
    }
  },
  methods: {
    async search() {
      await this.$http.get('/org_major/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    showInfoWindow() {
      this.showWindow = true
    },
    hideInfoWindow() {
      this.showWindow = false
      this.formInfo = {
        id: 0,
        type: '',
        major_name: '',
        position: '',
        org_name: '',
        name: '',
        dep_name: '',
        duty: '',
      }
    },
    async saveInfo() {
      if(this.formInfo.id){
        await this.$http.put('/org_major/' + this.formInfo.id + '/', this.formInfo).then((data) => {
          if (data.id) {
            this.$layer.msg("修改成功！")
            this.hideInfoWindow()
            this.search()
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })
      }else{
        await this.$http.post('/org_major/', this.formInfo).then((data) => {
          if (data.id) {
            this.$layer.msg("添加成功！")
            this.hideInfoWindow()
            this.search()
          } else {
            this.$layer.msg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('添加失败！')
        })
      }
    },
    async delInfo(id) {
      const url = '/org_major/' + id + '/'
      await this.$http.delete(url, ).then((data) => {
        console.log(data)
        this.$layer.msg('删除成功！');
        this.search()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('删除失败！');
      })
    },
    askDel(id) {
      this.$parent.$parent.$parent.showConfirm('确定要删除吗？', () => {
        this.delInfo(id)
      });
    },
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    },
    formatType(type){
      if(type in this.dict_org_major_type){
        return this.dict_org_major_type[type]
      }else{
        return ""
      }
    },
    async querySingle(id) {
      const url = '/org_major/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = {
          id: data.id,
          type: data.type,
          major_name: data.major_name,
          position: data.position,
          org_name: data.org_name,
          name: data.name,
          dep_name: data.dep_name,
          duty: data.duty,
        }
        this.showInfoWindow()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('数据获取失败！');
      })
    },
    askShow(id, v) {
      let doName = v === 1 ? '设为显示' : '设为不显示'
      this.$parent.$parent.$parent.showConfirm('确定要' + doName + '吗？', async () => {
        await this.$http.put('/org_major/' + id + '/',{
          is_show: v
        }).then((data) => {
          if (data.id) {
            this.$layer.msg(doName + "成功！")
            this.hideInfoWindow()
            this.search()
          } else {
            this.$layer.msg(doName + '失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg(doName + '失败！')
        })
      });
    },
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    async xlsChange() {
      console.log(this.uploadedCsv)
      const uploadUrl = '/files/' + this.$refs.xlsFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.xlsFile.files[0]).then((data) => {
        this.uploadedCsv = data
      }).catch(() => {
        this.$parent.$parent.showMsg('上传失败！')
      })
    },
    async submitCsv() {
      const uploadUrl = '/get_csv/'
      await this.$http.get(uploadUrl, {
        params: {
          'file_name': this.uploadedCsv
        }
      }).then((data) => {

        if (data.length <= 1) {
          this.$parent.$parent.showMsg('表格中无数据！')
          return;
        }

        data.splice(0, 1)

        this.uploadedCscData = data

        this.hideUploadWindow()
        this.uploadedCsv=''
        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()

      }).catch(() => {
        this.$parent.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {


      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.search()
        return;
      }

      let row = this.uploadedCscData[this.curCsvIndex]

      // region 数据检查开始

      if (row[0].trim().length == 0) {
        this.errorList.push({code: 0, text: '[' + row[0] + ']' + '请输入专业类领域！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }


      if (row[1].trim().length == 0) {
        this.errorList.push({code: 0, text: '[' + row[1] + ']' + '请输入专委会名称！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }

      if (row[2].trim().length == 0) {
        this.errorList.push({code: 0, text: '[' + row[2] + ']' + '请输入职位！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }
      if (row[3].trim().length == 0) {
        this.errorList.push({code: 0, text: '[' + row[3] + ']' + '请输入单位！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }
      if (row[4].trim().length == 0) {
        this.errorList.push({code: 0, text: '[' + row[4] + ']' + '请输入姓名！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }
      if (row[5].trim().length == 0) {
        this.errorList.push({code: 0, text: '[' + row[5] + ']' + '请输入所在部门！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }
      if (row[6].trim().length == 0) {
        this.errorList.push({code: 0, text: '[' + row[6] + ']' + '请输入职称！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }
      if (row[7].trim().length == 0) {
        row[7]=0
      }


      // endregion 数据检查结束
      let findKey=(value,compare=(a,b)=>a===b)=>{
        return Object.keys(this.dict_org_major_type).find(k=>compare(this.dict_org_major_type[k],value))
      }
      if(!findKey(row[0])){
        this.errorList.push({code: 0, text: '[' + row[0] + ']' + '该专业类领域找不到！'})
        this.curCsvIndex++
        await this.insertOne()
        return;
      }
      let addForm = {
        type: findKey(row[0]),
        major_name: row[1],
        position: row[2],
        org_name: row[3],
        name: row[4],
        dep_name: row[5],
        duty: row[6],
        is_show:row[7]
      }


      console.log('=======正在插入Application========')
      console.log(addForm)

      await this.$http.post('/org_major/', addForm).then(async (data) => {
        console.dir(data)
        this.errorList.push({code: 1, text: '[' + addForm.major_name+ ']' + "导入成功！"})
        this.curCsvIndex++
        this.insertOne()

      }).catch((error) => {
        console.dir(error)
        this.errorList.push({code: 0, text: '[' + addForm.major_name + ']' + error.response.data[0]})
        this.curCsvIndex++
        this.insertOne()
      })
    },
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped>
.form_content .label {
  width: 120px;
  text-align: right;
  padding-right: 10px;
}
#searchSection .s-input {
  width: 120px;
}
#dialog_content2 {
  max-height: 200px;
  overflow-y: auto;
}
</style>
